import { createBrowserRouter, Navigate, Outlet, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { AdminShell } from "./components/AdminShell";
import { Login } from "./pages/Login";
import { JobsPage } from "./pages/dataengine/Jobs";
import { RunsPage } from "./pages/dataengine/Runs";
import { TablesPage } from "./pages/dataengine/Tables";
import { ReconcileQueuePage } from "./pages/dataengine/ReconcileQueue";
import { FloorplanInspectorPage } from "./pages/dataengine/FloorplanInspector";
import { AddProjectPage } from "./pages/dataengine/AddProject";
import { UsersPage } from "./pages/accounts/Users";
import { StatsPage } from "./pages/accounts/Stats";
import { ReviewQueuePage } from "./pages/editorial/ReviewQueue";
import { ArticlesListPage } from "./pages/editorial/ArticlesList";
import { ComposePage } from "./pages/editorial/Compose";
import { ArticleReviewPage } from "./pages/editorial/ArticleReview";
import { AuthorsPage } from "./pages/editorial/Authors";
import { TopicsPage } from "./pages/editorial/Topics";
import { ArticleCommentsModerationPage } from "./pages/moderation/ArticleComments";
import { PropertyReviewsModerationPage } from "./pages/moderation/PropertyReviews";
import { SupportInboxPage } from "./pages/support/Inbox";
import { SupportThreadPage } from "./pages/support/Thread";
import { AuditPage } from "./pages/system/Audit";
import { SettingsPage } from "./pages/system/Settings";

function AuthRoot() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

function RequireAdmin() {
  const { admin, pending } = useAuth();
  const loc = useLocation();
  if (pending) return null;
  if (!admin) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  {
    element: <AuthRoot />,
    children: [
      { path: "/login", element: <Login /> },
      {
        element: <RequireAdmin />,
        children: [
          {
            element: <AdminShell />,
            children: [
              // Default landing — Editorial > Review queue. Operators
              // start their day looking at what needs sign-off.
              { index: true, element: <Navigate to="/editorial/review" replace /> },

              // Editorial
              { path: "editorial/review",       element: <ReviewQueuePage /> },
              { path: "editorial/compose",      element: <ComposePage /> },
              { path: "editorial/compose/:id",  element: <ComposePage /> },
              { path: "editorial/articles",     element: <ArticlesListPage /> },
              { path: "editorial/articles/:id", element: <ArticleReviewPage /> },
              { path: "editorial/authors",      element: <AuthorsPage /> },
              { path: "editorial/topics",       element: <TopicsPage /> },

              // Data engine
              { path: "dataengine/jobs",      element: <JobsPage /> },
              { path: "dataengine/runs",      element: <RunsPage /> },
              { path: "dataengine/tables",    element: <TablesPage /> },
              { path: "dataengine/addproject",      element: <AddProjectPage /> },
              { path: "dataengine/reconcile",       element: <ReconcileQueuePage /> },
              { path: "dataengine/reconcile/:slug", element: <FloorplanInspectorPage /> },

              // Moderation (epic PROP-72)
              { path: "moderation/property-reviews", element: <PropertyReviewsModerationPage /> },
              // Moderation (epic PROP-73)
              { path: "moderation/article-comments", element: <ArticleCommentsModerationPage /> },

              // Support (PROP-163)
              { path: "support/inbox",     element: <SupportInboxPage /> },
              { path: "support/inbox/:id", element: <SupportThreadPage /> },

              // Accounts
              { path: "accounts/users", element: <UsersPage /> },
              { path: "accounts/stats", element: <StatsPage /> },

              // System
              { path: "system/audit",    element: <AuditPage /> },
              { path: "system/settings", element: <SettingsPage /> },
            ],
          },
        ],
      },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
